<template>
  <Modal
    :visible="isModal"
    pop_tit="패치 접수 수정 사유 작성"
    popSizeClass="popup__container--l"
    @close="closeModal"
  >
    <template #pop_content>
      <div class="reason-modal-content">
        <table class="board-write type-block--mobile">
          <caption>
            패치 수정 이유 목록
          </caption>
          <tbody>
            <tr>
              <th scope="row">
                수정 사유<span
                  class="svg_icon icon_must"
                  aria-hidden="true"
                ></span
                ><span class="sr-only">필수입력</span>
              </th>
              <td>
                <div style="padding-bottom: 5px">
                  <label for="input1" class="sr-only"></label
                  ><select v-model="selectedReasonCode" id="reason-select">
                    <option :value="null" disabled>
                      수정 사유를 선택하세요
                    </option>
                    <option
                      v-for="item in items"
                      :key="item.cd"
                      :value="item.cd"
                    >
                      {{ item.cdNm }}
                    </option>
                  </select>
                </div>
                <textarea
                  placeholder="패치 수정 사유 내용을 작성하여 주시기 바랍니다."
                  v-show="selectedReasonCode === 'PATCH_MOD_INPUT'"
                  class="chat__textarea"
                  id="chat-input"
                  v-model="description"
                ></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template #pop_buttons>
      <button
        type="button"
        class="btn btn--m btn--blue"
        @click="applySelectionReason"
      >
        선택 완료
      </button>
    </template>
  </Modal>
</template>
<script>
import Modal from "@/component/Modal.vue";
import { inject, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  components: { Modal },
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const axios = inject("axios");
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const items = ref([]);
    const selectedReasonCode = ref(null);
    const description = ref("");

    //methods 정의
    const getPatchModCode = () => {
      showLoading();
      axios
        .post("/patch/pr/code/patch-mod/get")
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            items.value = res.data.resList;
          } else {
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.error(error);
          items.value = [];
        })
        .finally(() => {
          hideLoading();
        });
    };

    const closeModal = () => {
      emit("close");
    };

    const applySelectionReason = () => {
      emit("set", {
        reasonCode: selectedReasonCode.value,
        description: description.value,
      });
    };

    // life cycle 정의
    onMounted(() => {
      getPatchModCode();
    });

    // html에서 사용될 데이터 정의
    return {
      items,
      selectedReasonCode,
      description,
      closeModal,
      applySelectionReason,
    };
  },
};
</script>
